import React, {Fragment} from "react";
import {Button, Form} from "react-bootstrap";
import Icon from "../Icon";
import add_participant from "../../../assets/svg/actions/icn-add-participant-48px-48px-grey.svg";
import "../../../assets/sass/components/messages/group-blank-participants.scss";

class ChatGroupBlankParticipants extends React.Component {

    onClick = (event) => {
        event.preventDefault();
        if(this.props.onAddParticipantsClick)
            this.props.onAddParticipantsClick(event);
    }

    render() {
        return (
            <div className="group-blank-participants-wrapper">
                <div className="group-blank-participants">
                    <Icon svg={add_participant}/>
                    <h4>No Participant Added Yet</h4>
                    <p>Please add participants to start conversations</p>
                    <Button variant="primary" className="btn-md btn-block" onClick={this.onClick}>Add Participants</Button>
                </div>
            </div>
        )
    }
}

export default ChatGroupBlankParticipants;
